// extracted by mini-css-extract-plugin
export default {"button":"do-z","reviewSort":"eo-z"};